<template>
  <div class="sale-create">
    <el-card class="box-card" shadow="hover">
      <!-- 添加标题区 -->
      <div class="page-header">
        <div class="title">
          <i class="el-icon-shopping-cart-2"></i>
          <span>销售下单</span>
        </div>
      </div>

      <div class="form-container">
        <el-form :model="form" :rules="rules" ref="form" label-width="100px" size="small">
          <!-- 合并后的表单区域 -->
          <div class="form-section">
            <el-row :gutter="20">
              <!-- 基本信息 -->
              <el-col :span="6">
                <el-form-item label="商品编号" prop="productNo">
                  <el-input v-model="form.productNo" placeholder="请输入商品编号" prefix-icon="el-icon-goods">
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="经销商类型" prop="dealerType">
                  <el-select v-model="form.dealerType" placeholder="请选择">
                    <el-option label="类型1" value="1"></el-option>
                    <el-option label="类型2" value="2"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="经销商" prop="dealer">
                  <el-select v-model="form.dealer" placeholder="请选择">
                    <el-option label="经销商1" value="1"></el-option>
                    <el-option label="经销商2" value="2"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="代理商" prop="agent">
                  <el-select v-model="form.agent" placeholder="请选择">
                    <el-option label="代理商1" value="1"></el-option>
                    <el-option label="代理商2" value="2"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>

              <!-- 金额信息 -->
              <el-row :gutter="20">
              <el-col :span="6">
                <el-form-item label="商品数量" prop="quantity">
                  <el-input-number v-model="form.quantity" :min="1" placeholder="请输入" style="width: 270px;"></el-input-number>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="应收货款">
                  <div class="amount-input">
                    <el-input v-model="form.receivable" placeholder="20"></el-input>
                    <span class="unit">元</span>
                  </div>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="应收押金">
                  <div class="amount-input">
                    <el-input v-model="form.deposit" placeholder="请输入"></el-input>
                    <span class="unit">元</span>
                  </div>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="应收总额">
                  <div class="amount-input">
                    <el-input v-model="form.totalAmount" placeholder="请输入"></el-input>
                    <span class="unit">元</span>
                  </div>
                </el-form-item>
              </el-col>

              </el-row>

              <!-- 订单状态 -->
            <el-row :gutter="20">
              <el-col :span="6">
                <el-form-item label="结算状态">
                  <el-select v-model="form.settlementStatus" placeholder="请选择">
                    <el-option label="未结算" value="0"></el-option>
                    <el-option label="已结算" value="1"></el-option>
                    <el-option label="部分结算" value="2"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="结算时间">
                  <el-date-picker v-model="form.settlementTime" type="datetime" placeholder="选择日期时间"
                    value-format="yyyy-MM-dd HH:mm:ss">
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="订单状态">
                  <el-select v-model="form.orderStatus" placeholder="请选择">
                    <el-option label="待确认" value="0"></el-option>
                    <el-option label="已确认" value="1"></el-option>
                    <el-option label="已取消" value="2"></el-option>
                    <el-option label="已完成" value="3"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="订单时间">
                  <el-date-picker v-model="form.orderTime" type="datetime" placeholder="选择日期时间"
                    value-format="yyyy-MM-dd HH:mm:ss">
                  </el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>

              <!-- 备注信息 -->
              <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="备注">
                  <el-input type="textarea" :rows="2" placeholder="请输入备注信息" v-model="form.remark">
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </div>

          <!-- 按钮组 -->
          <div class="button-section">
            <div class="button-group">
              <el-button type="primary" size="small" icon="el-icon-document-copy" @click="openSubOrderDialog">
                子订单
              </el-button>
              <el-button type="danger" size="small" icon="el-icon-refresh-left" @click="handleReturnGoods">
                退换货
              </el-button>
              <el-button type="warning" size="small" icon="el-icon-upload2" @click="showUploadDialog">
                上传凭证
              </el-button>
              <el-button type="success" size="small" icon="el-icon-folder-checked">
                保存订单
              </el-button>
              <el-button type="info" size="small" icon="el-icon-check">
                核准审核
              </el-button>
              <el-button class="custom-button" size="small" icon="el-icon-view">
                审核状态
              </el-button>
            </div>
          </div>

          <!-- 表格优化 -->
          <div class="table-section">
            <div class="section-title">
              <i class="el-icon-list"></i>
              <span>订单明细</span>
            </div>
            <!-- 添加 tabs 标签页 -->
            <el-tabs v-model="activeTab" type="card" class="order-tabs">
              <el-tab-pane label="子订单" name="subOrder">
                <el-table :data="tableData" border stripe style="width: 100%" :header-cell-style="tableHeaderStyle"
                  v-loading="loading">
                  <el-table-column prop="productId" label="商品id" width="180"></el-table-column>
                  <el-table-column prop="receiver" label="收货人"></el-table-column>
                  <el-table-column prop="address" label="联系地址"></el-table-column>
                  <el-table-column prop="quantity" label="数量"></el-table-column>
                  <el-table-column prop="deposit" label="押金"></el-table-column>
                  <el-table-column prop="payment" label="货款"></el-table-column>
                  <el-table-column label="操作" width="120">
                    <template slot-scope="scope">
                      <el-button type="text" @click="handleDelete(scope.$index)">删除</el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </el-tab-pane>

              <el-tab-pane label="退换货" name="return">
                <el-table :data="returnData" border stripe style="width: 100%" :header-cell-style="tableHeaderStyle">
                  <el-table-column prop="returnId" label="退换货单号" width="180"></el-table-column>
                  <el-table-column prop="productId" label="商品编号"></el-table-column>
                  <el-table-column label="退换类型" width="120">
                    <template slot-scope="scope">
                      <el-select v-model="scope.row.returnType" size="mini" placeholder="请选择">
                        <el-option label="退货" value="1"></el-option>
                        <el-option label="换货" value="2"></el-option>
                      </el-select>
                    </template>
                  </el-table-column>
                  <el-table-column prop="quantity" label="数量"></el-table-column>
                  <el-table-column prop="reason" label="原因"></el-table-column>
                  <el-table-column prop="status" label="状态"></el-table-column>
                </el-table>
              </el-tab-pane>

              <el-tab-pane label="凭证" name="voucher">
                <el-table :data="voucherData" border stripe style="width: 100%" :header-cell-style="tableHeaderStyle">
                  <el-table-column prop="voucherId" label="凭证编号" width="180"></el-table-column>
                  <el-table-column prop="type" label="凭证类型"></el-table-column>
                  <el-table-column prop="amount" label="金额"></el-table-column>
                  <el-table-column prop="uploadTime" label="上传时间"></el-table-column>
                  <el-table-column prop="status" label="状态"></el-table-column>
                  <el-table-column label="操作" width="120">
                    <template slot-scope="scope">
                      <el-button type="text" @click="previewVoucher(scope.row)">查看</el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </el-tab-pane>

              <el-tab-pane label="审批进度" name="approval">
                <div class="approval-timeline">
                  <div class="timeline-item" v-for="(activity, index) in activities" :key="index">
                    <div class="timeline-node" :class="activity.type">
                      <i :class="getIconByType(activity.type)"></i>
                    </div>
                    <div class="timeline-content">
                      <div class="content">{{ activity.content }}</div>
                      <div class="timestamp">{{ activity.timestamp }}</div>
                    </div>
                    <div class="timeline-line" v-if="index !== activities.length - 1"></div>
                  </div>
                </div>
              </el-tab-pane>
            </el-tabs>
          </div>
        </el-form>
      </div>
    </el-card>

    <!-- 添加子订单弹窗 -->
    <el-dialog title="子订单" :visible.sync="subOrderDialogVisible" width="55%" :before-close="handleClose"
      custom-class="sub-order-dialog">
      <div class="sub-order-form">
        <!-- 添加 tabs 组件 -->
        <el-tabs v-model="subOrderActiveTab">
          <el-tab-pane label="基本信息" name="basic">
            <!-- 原有的表单内容 -->
            <el-form :model="subOrderForm" label-width="100px" size="small">
              <!-- 第一行 -->
              <el-row :gutter="20">
                <el-col :span="8">
                  <el-form-item label="订单编号">
                    <el-input v-model="subOrderForm.orderNo" placeholder="123456"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="收货人">
                    <el-input v-model="subOrderForm.receiver" placeholder="请输入..."></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="联系电话">
                    <el-input v-model="subOrderForm.phone" placeholder="请输入..."></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <!-- 第二行 - 收货地址 -->
              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item label="收货地址">
                    <el-input v-model="subOrderForm.address" placeholder="请输入..."></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <!-- 第三行 -->
              <el-row :gutter="20">
                <el-col :span="8">
                  <el-form-item label="物流方式">
                    <el-select v-model="subOrderForm.logisticsType" placeholder="请选择">
                      <el-option label="快递" value="1"></el-option>
                      <el-option label="自提" value="2"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="物流单号">
                    <el-input v-model="subOrderForm.logisticsNo" placeholder="请输入..."></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="物流状态">
                    <el-input v-model="subOrderForm.logisticsStatus" placeholder="请输入..."></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <!--  -->
              <el-row :gutter="20">
                <el-col :span="8">
                  <el-form-item label="应收货款">
                    <div class="amount-input">
                      <el-input v-model="subOrderForm.payment" placeholder="20"></el-input>
                      <span class="unit">元</span>
                    </div>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="应收押金">
                    <div class="amount-input">
                      <el-input v-model="subOrderForm.deposit" placeholder="请输入..."></el-input>
                      <span class="unit">元</span>
                    </div>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="物流费用">
                    <div class="amount-input">
                      <el-input v-model="subOrderForm.logisticsFee" placeholder="请输入..."></el-input>
                      <span class="unit">元</span>
                    </div>
                  </el-form-item>
                </el-col>
                <div class="basic-info-footer" style="text-align: left;">
                  <el-button type="primary" size="small" @click="handleAddBasicInfo">新增</el-button>
                  <el-button type="success" size="small" @click="handleSaveBasicInfo">保存</el-button>
                </div>
              </el-row>
              <!-- 修改按钮容器的样式和位置 -->

            </el-form>

            <!-- 添加表格 -->
            <div class="basic-info-table">
              <el-table :data="basicInfoTableData" border stripe style="width: 100%"
                :header-cell-style="tableHeaderStyle">
                <el-table-column prop="productId" label="商品编号" width="120"></el-table-column>
                <el-table-column prop="productName" label="商品名称"></el-table-column>
                <el-table-column prop="productQuantity" label="商品数量"></el-table-column>
                <el-table-column prop="productPrice" label="商品规格"></el-table-column>
                <el-table-column prop="productStock" label="商品存货"></el-table-column>
                <el-table-column prop="remark" label="备注"></el-table-column>
                <el-table-column label="操作" width="150">
                  <template slot-scope="scope">
                    <el-button type="text" size="small" @click="handleView(scope.row)">查看</el-button>
                    <el-button type="text" size="small" @click="handleEdit(scope.row)">编辑</el-button>
                    <el-button type="text" size="small" @click="handleDelete(scope.$index)">删除</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </el-tab-pane>

          <el-tab-pane label="增加商品" name="addProduct">
            <div class="add-product-container">
              <!-- 搜索区域 -->
              <div class="search-section">
                <el-form :inline="true" :model="addProductForm" size="small">
                  <el-form-item label="商品类别">
                    <el-select v-model="addProductForm.category" placeholder="请选择" style="width: 200px;">
                      <el-option label="类别1" value="1"></el-option>
                      <el-option label="类别2" value="2"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="商品名称">
                    <el-input v-model="addProductForm.productName" placeholder="请输入商品类别"
                      style="width: 200px;"></el-input>
                  </el-form-item>
                  <el-button type="primary" icon="el-icon-search" style="margin-left: 10px;">搜索</el-button>
                  <el-button icon="el-icon-refresh">重置</el-button>
                </el-form>
              </div>

              <!-- 表格区域 -->
              <div class="product-table">
                <el-table :data="productTableData" border stripe style="width: 100%"
                  :header-cell-style="tableHeaderStyle">
                  <el-table-column type="selection" width="55"></el-table-column>
                  <el-table-column prop="productId" label="商品id" width="120"></el-table-column>
                  <el-table-column prop="productCategory" label="商品类别"></el-table-column>
                  <el-table-column prop="productNumber" label="商品数量"></el-table-column>
                  <el-table-column prop="productPrice" label="商品规格"></el-table-column>
                  <el-table-column prop="productStock" label="商品存货"></el-table-column>
                  <el-table-column label="操作" width="120">
                    <template slot-scope="scope">
                      <el-button type="text" size="small" @click="handleDelete(scope.$index)">删除</el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </div>

              <!-- 添加底部表单 -->
              <div class="bottom-form">
                <el-form :inline="true" :model="addProductForm" size="small">
                  <el-row :gutter="20">
                    <el-col :span="8">
                      <el-form-item label="商品id">
                        <el-input v-model="addProductForm.productId" placeholder="请输入..."></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="8">
                      <el-form-item label="商品类别">
                        <el-input v-model="addProductForm.category" placeholder="请输入..."></el-input>
                      </el-form-item>
                    </el-col>

                    <el-col :span="8">
                      <el-form-item label="商品型号">
                        <el-input v-model="addProductForm.model" placeholder="请输入..."></el-input>
                      </el-form-item>
                    </el-col>

                  </el-row>
                  <el-row :gutter="20">
                    <el-col :span="8">
                      <el-form-item label="商品规格">
                        <el-input v-model="addProductForm.specification" placeholder="请输入..."></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="8">
                      <el-form-item label="商品存货">
                        <el-input v-model="addProductForm.stock" placeholder="请输入..."></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="8">
                      <el-form-item label="最低押金">
                        <el-input v-model="addProductForm.minDeposit" placeholder="请输入..."></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="20">
                    <el-col :span="8">
                      <el-form-item label="最低售价">
                        <el-input v-model="addProductForm.minPrice" placeholder="请输入..."></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="8">
                      <el-form-item label="商品数量">
                        <el-input v-model="addProductForm.quantity" placeholder="请输入..."></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="8">
                      <el-button type="primary" size="small" style="margin-left: 10px;">确定</el-button>
                      <el-button size="small">返回</el-button>
                    </el-col>
                  </el-row>
                </el-form>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>

        <!-- 表格部分保留，但删除底部按钮 -->

      </div>
    </el-dialog>

    <!-- 退换货弹窗 -->
    <el-dialog title="退换货申请" :visible.sync="returnDialogVisible" width="55%" :before-close="handleReturnDialogClose"
      custom-class="return-dialog">
      <div class="return-form">
        <el-form :model="returnForm" label-width="100px" size="small">
          <!-- 第一行 -->
          <el-row :gutter="20">
            <el-col :span="8">
              <el-form-item label="原订单号">
                <el-input v-model="returnForm.originalOrderNo" placeholder="请输入原订单号"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="退换类型">
                <el-select v-model="returnForm.returnType" placeholder="请选择">
                  <el-option label="退货" value="1"></el-option>
                  <el-option label="换货" value="2"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="申请时间">
                <el-date-picker v-model="returnForm.applyTime" type="datetime" placeholder="选择日期时间">
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>

          <!-- 第二行 -->
          <el-row :gutter="20">
            <el-col :span="8">
              <el-form-item label="退货数量">
                <el-input-number v-model="returnForm.quantity" :min="1"></el-input-number>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="退款金额">
                <div class="amount-input">
                  <el-input v-model="returnForm.refundAmount" placeholder="请输入金额"></el-input>
                  <span class="unit">元</span>
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="退货原因">
                <el-select v-model="returnForm.reason" placeholder="请选择">
                  <el-option label="质量问题" value="1"></el-option>
                  <el-option label="规格不符" value="2"></el-option>
                  <el-option label="商品损坏" value="3"></el-option>
                  <el-option label="其他原因" value="4"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="8">
              <el-form-item label="发货人">
                <el-input v-model="returnForm.refundAmount" placeholder="请输入发货人"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="联系电话">
                <el-input v-model="returnForm.refundAmount" placeholder="请输入联系电话"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="发货地址">
                <el-input v-model="returnForm.refundAmount" placeholder="请输入发货地址"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <!-- 第三行 -->
          <el-row :gutter="20">
            <el-col :span="8">
              <el-form-item label="物流单号">
                <el-input v-model="returnForm.logisticsNo" placeholder="请输入物流单号"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="16">
              <el-form-item label="详细说明">
                <el-input type="textarea" :rows="3" placeholder="请输入详细说明" v-model="returnForm.description">
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <!-- 图片上传 -->
          <el-row>
            <el-col :span="24">
              <el-form-item label="上传凭证">
                <el-upload action="#" list-type="picture-card" :auto-upload="false" :file-list="returnForm.fileList"
                  :on-preview="handlePictureCardPreview" :on-remove="handleRemove">
                  <i class="el-icon-plus"></i>
                </el-upload>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>

        <!-- 商品列表 -->
        <div class="return-goods-list">
          <div class="section-title">
            <i class="el-icon-goods"></i>
            <span>退换商品列表</span>
          </div>
          <el-table :data="returnGoodsList" border stripe style="width: 100%" :header-cell-style="tableHeaderStyle">
            <el-table-column prop="productId" label="商品编号" width="120"></el-table-column>
            <el-table-column prop="productName" label="商品名称"></el-table-column>
            <el-table-column prop="specification" label="规格型号"></el-table-column>
            <el-table-column prop="quantity" label="数量" width="100"></el-table-column>
            <el-table-column prop="price" label="单价" width="120"></el-table-column>
            <el-table-column prop="amount" label="金额" width="120"></el-table-column>
            <el-table-column label="操作" width="120">
              <template slot-scope="scope">
                <el-button type="text" size="small" @click="handleDeleteReturnGoods(scope.$index)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="returnDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleSubmitReturn">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 添加上传凭证弹窗 -->
    <el-dialog title="上传凭证" :visible.sync="uploadDialogVisible" width="50%">
      <el-form :model="uploadForm" label-width="100px" size="small">
        <el-form-item label="收付款类型">
          <el-select v-model="uploadForm.paymentType" placeholder="请选择" style="width: 100%">
            <el-option label="收款" value="receive"></el-option>
            <el-option label="付款" value="pay"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="收付款渠道">
          <el-select v-model="uploadForm.paymentChannel" placeholder="请选择" style="width: 100%">
            <el-option v-for="item in paymentChannels" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="收付款账户">
          <el-select v-model="uploadForm.paymentAccount" placeholder="请选择" style="width: 100%">
            <el-option v-for="item in paymentAccounts" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="收付款金额">
          <el-input v-model="uploadForm.amount" placeholder="请输入金额">
            <template slot="append">元</template>
          </el-input>
        </el-form-item>

        <el-form-item label="上传凭证">
          <el-upload action="/api/upload" :file-list="uploadForm.fileList" :limit="1" accept=".jpg,.png"
            list-type="picture-card">
            <i class="el-icon-plus"></i>
          </el-upload>
          <div class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="uploadDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitUpload">提 交</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<style lang="scss" scoped>
.sale-create {
  padding: 10px;
  background-color: #f5f7fa;

  .box-card {
    border-radius: 8px;
    border: none;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);
  }

  .page-header {
    position: relative;
    height: 80px;
    margin: -10px -20px 30px;
    padding: 0 24px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: linear-gradient(135deg, #1890ff, #36cfc9);
    overflow: hidden;

    /* 添加科技感背景 */
    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background-image: linear-gradient(45deg, rgba(255,255,255,0.1) 25%, transparent 25%), linear-gradient(-45deg, rgba(255,255,255,0.1) 25%, transparent 25%), linear-gradient(45deg, transparent 75%, rgba(255,255,255,0.1) 75%), linear-gradient(-45deg, transparent 75%, rgba(255,255,255,0.1) 75%);
      background-size: 20px 20px;
      background-position: 0 0, 0 10px, 10px -10px, -10px 0px;
      animation: backgroundMove 20s linear infinite;
    }

    /* 添加动态光效 */
    &::after {
      content: '';
      position: absolute;
      top: 0;
      left: -150%;
      width: 150%;
      height: 100%;
      background: linear-gradient(
        90deg,
        transparent,
        rgba(255, 255, 255, 0.1),
        transparent
      );
      transform: skewX(-20deg);
      animation: shine 8s infinite;
    }

    .title {
      position: relative;
      z-index: 1;
      display: flex;
      align-items: center;
      
      i {
        width: 40px;
        height: 40px;
        margin-right: 12px;
        background: rgba(255, 255, 255, 0.2);
        border-radius: 10px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 24px;
        color: #fff;
        backdrop-filter: blur(5px);
      }

      span {
        font-size: 20px;
        font-weight: 500;
        color: #fff;
        text-shadow: 0 2px 4px rgba(0,0,0,0.1);
      }
    }
  }

  /* 添加动画 */
  @keyframes backgroundMove {
    0% {
      background-position: 0 0, 0 10px, 10px -10px, -10px 0px;
    }
    100% {
      background-position: -20px -20px, -20px -10px, -10px -30px, -30px -20px;
    }
  }

  @keyframes shine {
    0% {
      left: -150%;
    }
    50% {
      left: 100%;
    }
    100% {
      left: 100%;
    }
  }

  .form-section {
    background: #fff;
    border-radius: 8px;
    padding: 20px;
    margin-bottom: 20px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.02);
    transition: all 0.3s ease;

    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 4px 16px 0 rgba(0, 0, 0, 0.08);
    }
  }

  .table-section {
    background: #fff;
    border-radius: 8px;
    padding: 20px;
    margin-top: 20px;

    .el-table {
      border-radius: 8px;
      overflow: hidden;
    }
  }

  // 输入框样式优化
  .el-input {
    .el-input__inner {
      border-radius: 4px;
      border: 1px solid #dcdfe6;
      transition: all 0.3s ease;

      &:focus {
        border-color: #409EFF;
        box-shadow: 0 0 8px rgba(64, 158, 255, 0.2);
      }
    }
  }

  // 下拉框样式优化
  .el-select {
    width: 100%;
  }

  .amount-input {
    display: flex;
    align-items: center;

    .el-input {
      flex: 1;
    }

    .unit {
      margin-left: 8px;
      color: #606266;
    }
  }

  .button-section {
    margin: -10px 0 10px 0;
    padding-left: 20px;

    .button-group {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      gap: 8px;

      .el-button {
        padding: 8px 16px;
        border-radius: 4px;
        font-size: 13px;

        &:hover {
          transform: translateY(-1px);
          box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
        }

        [class^="el-icon-"] {
          margin-right: 4px;
          font-size: 14px;
        }

        // 自定义每个按钮的颜色
        &.el-button--primary {
          background-color: #409EFF;
          border-color: #409EFF;
        }

        &.el-button--danger {
          background-color: #F56C6C;
          border-color: #F56C6C;
        }

        &.el-button--warning {
          background-color: #E6A23C;
          border-color: #E6A23C;
        }

        &.el-button--success {
          background-color: #67C23A;
          border-color: #67C23A;
        }

        &.el-button--info {
          background-color: #909399;
          border-color: #909399;
        }

        &.custom-button {
          background-color: #8E44AD;
          border-color: #8E44AD;
          color: #fff;
        }
      }
    }
  }
}

// 修复深度选择器语法
:deep(.el-form-item.is-required .el-form-item__label:before) {
  content: '*';
  color: #F56C6C;
  margin-right: 4px;
}

:deep(.el-date-editor.el-input) {
  width: 100%;
}

.order-tabs {
  margin-top: 20px;

  :deep(.el-tabs__header) {
    margin-bottom: 20px;
  }

  :deep(.el-tabs__item) {
    height: 40px;
    line-height: 40px;
    font-size: 14px;
    color: #606266;

    &.is-active {
      color: #409EFF;
      font-weight: 500;
    }
  }
}

.approval-timeline {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 40px 20px;
  background: #fff;
  border-radius: 8px;
  position: relative;

  .timeline-item {
    flex: 1;
    display: flex;
    align-items: center;
    position: relative;

    .timeline-node {
      width: 32px;
      height: 32px;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      background: #f0f2f5;
      z-index: 2;

      i {
        font-size: 16px;
        color: #fff;
      }

      &.primary {
        background-color: #409EFF;
      }

      &.success {
        background-color: #67C23A;
      }

      &.warning {
        background-color: #E6A23C;
      }

      &.danger {
        background-color: #F56C6C;
      }
    }

    .timeline-content {
      margin-left: 12px;
      min-width: 120px;

      .content {
        font-size: 14px;
        color: #303133;
        margin-bottom: 4px;
        font-weight: 500;
      }

      .timestamp {
        font-size: 12px;
        color: #909399;
      }
    }

    .timeline-line {
      position: absolute;
      height: 2px;
      background: #E4E7ED;
      left: 32px;
      right: 0;
      top: 50%;
      transform: translateY(-50%);
      z-index: 1;
    }
  }
}

.el-timeline {
  display: none;
}

.sub-order-form {
  height: 100%;
  display: flex;
  flex-direction: column;

  // 加表单区样式
  .el-form {
    background-color: #fff;
    padding: 15px;
    border-radius: 6px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.03);

    .el-form-item {
      margin-bottom: 15px;

      &__label {
        font-weight: 500;
        color: #606266;
      }
    }

    // 修改收货地址输入框的样式
    .el-form-item[label="收货地址"] {
      .el-input {
        width: 250px !important;
      }

      .el-input__inner {
        width: 250px !important;
      }
    }
  }

  // 优化表格区域样式
  .sub-order-table {
    flex: 1;
    overflow-y: auto;
    margin: 15px 0;
    background-color: #fff;
    border-radius: 6px;
    padding: 15px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.03);

    .el-table {
      border: 1px solid #ebeef5;
      border-radius: 4px;
      overflow: hidden;
    }
  }

  // 特殊处理收货地址输入框
  .el-form-item[label="收货地址"] {
    .el-input {
      width: 250px !important;

      .el-input__inner {
        width: 250px !important;
      }
    }
  }

  .basic-info-footer {
    margin-top: 20px;
    padding: 20px 0 0 100px; // 左边距与表单项对齐
    border-top: 1px solid #ebeef5;

    .el-button {
      padding: 9px 25px;
      margin: 0 10px 0 0; // 只保留右边距
      font-weight: 500;

      &--primary {
        background: linear-gradient(135deg, #409EFF, #3a8ee6);
        border: none;

        &:hover {
          transform: translateY(-1px);
          box-shadow: 0 4px 12px rgba(64, 158, 255, 0.3);
        }
      }

      &--success {
        background: linear-gradient(135deg, #67C23A, #5daf34);
        border: none;

        &:hover {
          transform: translateY(-1px);
          box-shadow: 0 4px 12px rgba(103, 194, 58, 0.3);
        }
      }
    }
  }

  .basic-info-table {
    margin-top: 20px;
    padding: 20px;
    background-color: #fff;
    border-radius: 4px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.03);

    .el-table {
      border: 1px solid #ebeef5;
      border-radius: 4px;
      overflow: hidden;
    }
  }
}

// 优化金额输入框样式
.amount-input {
  .el-input {
    .el-input__inner {
      text-align: right;
      padding-right: 25px;
    }
  }

  .unit {
    position: absolute;
    right: 10px;
    top: 50%;
    transform: translateY(-50%);
    color: #909399;
  }
}

:deep(.sub-order-dialog) {
  .el-dialog__body {
    padding: 15px 20px;
    height: 55vh;
    overflow-y: auto;
  }

  .el-dialog__header {
    padding: 15px 20px;
    border-bottom: 1px solid #ebeef5;
    background-color: #f8f9fa;
  }

  .el-dialog__title {
    font-size: 16px;
    font-weight: 500;
    color: #303133;

    i {
      margin-right: 8px;
      color: #409EFF;
    }
  }
}

// 确保父容器不会限制宽度
.el-col-24 {
  .el-form-item[label="收货地址"] {
    width: auto;
    min-width: 250px;
  }
}

.add-product-container {
  .search-section {
    background-color: #fff;
    padding: 15px 20px;
    border-radius: 4px;
    margin-bottom: 20px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.03);

    .el-form {
      display: flex;
      align-items: center;
      flex-wrap: nowrap; // 防止换行

      .el-form-item {
        margin-bottom: 0;
        margin-right: 20px;
      }

      // 移除原有的按钮样式
      .el-button {
        padding: 9px 15px;
        margin-right: 10px;

        &:last-child {
          margin-right: 0;
        }
      }
    }
  }

  .product-table {
    margin: 20px 0;
  }

  .bottom-form {
    margin-top: 20px;
    padding: 20px;
    background-color: #fff;
    border-radius: 4px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.03);

    .el-form {
      .el-row {
        margin-bottom: 20px;  // 增加行间距

        &:last-child {
          margin-bottom: 0;
        }

        .el-col {
          .el-form-item {
            margin-bottom: 0;
            
            // 统一表单项宽度
            .el-input,
            .el-select {
              width: 100%;
            }

            // 调整label宽度和对齐方式
            .el-form-item__label {
              width: 80px;
              text-align: right;
              padding-right: 12px;
            }

            // 调整内容区域宽度
            .el-form-item__content {
              margin-left: 80px;
            }
          }

          // 最后一列包含按钮的特殊处理
          &:last-child {
            display: flex;
            align-items: center;
            justify-content: flex-start;

            .el-button {
              margin-left: 80px;  // 与表单项对齐
              &:not(:first-child) {
                margin-left: 10px;
              }
            }
          }
        }
      }
    }
  }
}

.return-dialog {
  .return-form {
    padding: 20px;

    .section-title {
      margin: 20px 0;
      font-size: 16px;
      font-weight: 500;
      color: #303133;
      display: flex;
      align-items: center;

      i {
        margin-right: 8px;
        color: #409EFF;
      }
    }

    .el-upload--picture-card {
      width: 100px;
      height: 100px;
      line-height: 100px;
    }

    .return-goods-list {
      margin-top: 20px;
    }
  }

  .dialog-footer {
    text-align: right;
    padding: 20px;
    border-top: 1px solid #ebeef5;
  }
}
</style>

<script>
export default {
  name: 'SaleCreate',
  data() {
    return {
      loading: false,
      form: {
        productNo: '123456',
        dealerType: '',
        dealer: '',
        agent: '',
        quantity: 1,
        receivable: '20',
        deposit: '',
        totalAmount: '',
        actualAmount: '',
        settlementStatus: '',
        settlementTime: '',
        orderStatus: '',
        orderTime: '',
        remark: ''
      },
      rules: {
        productNo: [{ required: true, message: '请输入商品编号', trigger: 'blur' }],
        dealerType: [{ required: true, message: '请选择经销商类型', trigger: 'change' }],
        dealer: [{ required: true, message: '请选择经销商', trigger: 'change' }],
        quantity: [{ required: true, message: '请输入商品数量', trigger: 'blur' }],
        settlementStatus: [
          { required: true, message: '请选择结算状态', trigger: 'change' }
        ],
        orderStatus: [
          { required: true, message: '请选择订单状态', trigger: 'change' }
        ],
        orderTime: [
          { required: true, message: '请选择订单时间', trigger: 'change' }
        ]
      },
      tableData: [
        {
          productId: '2016-05-02',
          receiver: '王小虎',
          address: '上海',
          quantity: '普陀区',
          deposit: '上海市',
          payment: '上海市'
        },
        {
          productId: '2016-05-04',
          receiver: '王小虎',
          address: '上海',
          quantity: '普陀区',
          deposit: '上海市',
          payment: '上海市'
        }
      ],
      activeTab: 'subOrder',
      returnData: [
        {
          returnId: 'RT2024001',
          productId: 'P001',
          returnType: '1',
          quantity: 1,
          reason: '商品损坏',
          status: '处理中'
        }
      ],
      voucherData: [
        {
          voucherId: 'V2024001',
          type: '付款凭证',
          amount: '1000.00',
          uploadTime: '2024-03-20 10:00:00',
          status: '已确认'
        }
      ],
      activities: [
        {
          content: '创建订单',
          timestamp: '2024-03-20 10:00:00',
          type: 'primary'
        },
        {
          content: '提交审核',
          timestamp: '2024-03-20 10:05:00',
          type: 'success'
        },
        {
          content: '财务审核通过',
          timestamp: '2024-03-20 11:00:00',
          type: 'success'
        },
        {
          content: '等待最终审批',
          timestamp: '2024-03-20 11:30:00',
          type: 'warning'
        }
      ],
      subOrderDialogVisible: false,
      subOrderForm: {
        orderNo: '123456',
        receiver: '',
        phone: '',
        address: '',
        payment: '20',
        logisticsType: '',
        logisticsNo: '',
        logisticsFee: '',
        logisticsStatus: ''
      },
      subOrderTableData: [
        {
          productId: '2016-05-02',
          productName: '王小虎',
          quantity: '上海',
          payment: '普陀区',
          deposit: '上海市',
          remark: ''
        },
        {
          productId: '2016-05-04',
          productName: '王小虎',
          quantity: '上海',
          payment: '普陀区',
          deposit: '上海市',
          remark: ''
        }
      ],
      subOrderActiveTab: 'basic',  // 新增 tabs 激活标签
      addProductForm: {           // 新增商品表单数据
        productId: '',
        productName: '',
        quantity: 1,
        deposit: '',
        payment: '',
        remark: ''
      },
      productTableData: [
        {
          productId: '2016-05-02',
          productCategory: '类别1',
          productNumber: '10',
          productPrice: '100',
          productStock: '1000'
        },
        {
          productId: '2016-05-04',
          productCategory: '类别2',
          productNumber: '20',
          productPrice: '200',
          productStock: '2000'
        }
      ],
      basicInfoTableData: [
        {
          productId: 'P001',
          productName: '商品1',
          productQuantity: 10,
          productPrice: '100',
          productStock: 1000,
          remark: '备注信息1'
        },
        {
          productId: 'P002',
          productName: '商品2',
          productQuantity: 20,
          productPrice: '200',
          productStock: 2000,
          remark: '备注信息2'
        }
      ],
      returnDialogVisible: false,
      returnForm: {
        originalOrderNo: '',
        returnType: '',
        applyTime: '',
        quantity: 1,
        refundAmount: '',
        reason: '',
        description: '',
        fileList: []
      },
      returnGoodsList: [
        {
          productId: 'P001',
          productName: '示例商品1',
          specification: '规格1',
          quantity: 1,
          price: '100.00',
          amount: '100.00'
        }
      ],
      // 新增数据
      uploadDialogVisible: false,
      uploadForm: {
        paymentType: '',
        paymentChannel: '',
        paymentAccount: '',
        amount: '',
        fileList: []
      },
      paymentChannels: [
        { label: '银行转账', value: 'bank' },
        { label: '支付宝', value: 'alipay' },
        { label: '微信支付', value: 'wechat' },
        { label: '现金', value: 'cash' }
      ],
      paymentAccounts: [
        { label: '工商银行账户', value: 'icbc' },
        { label: '建设银行账户', value: 'ccb' },
        { label: '支付宝商户号', value: 'alipay' },
        { label: '微信商户号', value: 'wechat' }
      ]
    }
  },
  methods: {
    handleDelete(index) {
      this.tableData.splice(index, 1)
    },
    calculateTotal() {
      // 计算应收总额
      const receivable = parseFloat(this.form.receivable) || 0
      const deposit = parseFloat(this.form.deposit) || 0
      this.form.totalAmount = (receivable + deposit).toFixed(2)
    },
    submitForm() {
      this.$refs.form.validate(valid => {
        if (valid) {
          // TODO: 调用API提交订单
          this.$message.success('订单提交成功')
        }
      })
    },
    // 表格表头样式
    tableHeaderStyle() {
      return {
        background: '#f5f7fa',
        color: '#606266',
        fontWeight: 500,
        fontSize: '14px'
      }
    },
    previewVoucher(row) {
      // 查看凭证的方法
      this.$message.info('查看凭证：' + row.voucherId)
    },
    getIconByType(type) {
      const iconMap = {
        primary: 'el-icon-edit',
        success: 'el-icon-check',
        warning: 'el-icon-loading',
        danger: 'el-icon-close'
      }
      return iconMap[type] || 'el-icon-more'
    },
    openSubOrderDialog() {
      this.subOrderDialogVisible = true
    },
    handleClose(done) {
      this.$confirm('确认关闭？')
        .then(_ => {
          done()
        })
        .catch(_ => { })
    },
    handleAddSubOrder() {
      // 处理新增子订单的逻辑
      this.$message.success('新增子订单成功')
    },
    handleSaveSubOrder() {
      // 处理保存子订单的逻辑
      this.$message.success('保存子订单成功')
      this.subOrderDialogVisible = false
    },
    handleView(row) {
      console.log('查看行:', row);
    },
    handleEdit(row) {
      console.log('编辑行:', row);
    },
    handleAddBasicInfo() {
      // 处理基本信息新增逻辑
      this.$message.success('新增基本信息成功')
    },
    handleSaveBasicInfo() {
      // 处理基本信息保存逻辑
      this.$message.success('保存基本信息成功')
    },
    handleReturnGoods() {
      this.returnDialogVisible = true
    },
    handleReturnDialogClose(done) {
      this.$confirm('确认关闭？')
        .then(_ => {
          done()
        })
        .catch(_ => { })
    },
    handlePictureCardPreview(file) {
      // 处理图片预览逻辑
    },
    handleRemove(file, fileList) {
      this.returnForm.fileList = fileList
    },
    handleDeleteReturnGoods(index) {
      this.returnGoodsList.splice(index, 1)
    },
    handleSubmitReturn() {
      // 这里添加提交退换货申请的逻辑
      this.$message.success('退换货申请提交成功')
      this.returnDialogVisible = false
    },
    showUploadDialog() {
      this.uploadDialogVisible = true
    },
    submitUpload() {
      this.$message.success('上传凭证成功')
      this.uploadDialogVisible = false
    }
  },
  watch: {
    'form.receivable': {
      handler: 'calculateTotal'
    },
    'form.deposit': {
      handler: 'calculateTotal'
    }
  }
}
</script>